// extracted by mini-css-extract-plugin
var _1 = "PeopleStyles-module__empty___kd_RM";
var _2 = "PeopleStyles-module__investors___Pbrw5";
var _3 = "PeopleStyles-module__investors--list___QTXg2";
var _4 = "PeopleStyles-module__investors--list___QTXg2";
var _5 = "PeopleStyles-module__show-all___VIEKW";
var _6 = "PeopleStyles-module__show-all-container___wnbi0";
var _7 = "PeopleStyles-module__show-all___VIEKW";
var _8 = "PeopleStyles-module__show-all-container___wnbi0";
export { _1 as "empty", _2 as "investors", _3 as "investors--list", _4 as "investorsList", _5 as "show-all", _6 as "show-all-container", _7 as "showAll", _8 as "showAllContainer" }
